<h1 mat-dialog-title >Nueva matriculación</h1>
<div mat-dialog-content>
  <form [formGroup]="matricualcionForm">

    <div class="row">

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Tipo de Trámite</mat-label>
        <select matInput matNativeControl formControlName="tipoTramite" (change)="changeEstado($event.target)">
          <option label="--Seleccionar--"></option>
          <option value="MATRICULACION TURISMO">Matriculación Turismo</option>
          <option value="MATRICULACION VEHICULO INDUSTRIAL">Matriculación Vehículo Industrial</option>
          <option value="MATRICULACION VEHICULO ESPECIAL">Matriculación Vehículo Especial</option>
          <option value="MATRICULACION MOTOCICLETA">Matriculación Motocicleta</option>
          <option value="MATRICULACION CICLOMOTOR">Matriculación Ciclomotor</option>
          <option value="MATRICULACION VEHICULO IMPORTACION">Matriculación Vehículo Importación</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Número de pedido</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="numPedido">

      </mat-form-field>

    </div>

    <div class="row" *ngIf="show">

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Km</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="km">

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>País de origen</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="paisOrigen">

      </mat-form-field>

    </div>




  </form>

</div>
<mat-dialog-actions align="end">
  <button mat-button  mat-dialog-close>Cancelar</button>
  <button mat-button   [disabled]="matricualcionForm.invalid" [mat-dialog-close]="matricualcionForm">Siguiente</button>
</mat-dialog-actions>
